var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{attrs:{"type":"info","outlined":""}},[_vm._v(" Ensure that you have processed all the documents required by your institution. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }